import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    table: {
      borderRadius: 4.8,
      border: `0.4rem solid ${palette.lightgrey}`,
      boxSizing: 'border-box',
      boxShadow: '0px 0px 3px 1px rgb(0 0 0 / 20%)',
      marginBottom: 20,
      overflowX: 'auto',
      maxHeight: 250,
    },
    tableTitle: {
      fontSize: 12,
      paddingBottom: 5,
      fontWeight: 500,
      marginLeft: 8,
      paddingTop: 4,

      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      cursor: 'pointer',
    },
    titleBackground: {
      backgroundColor: palette.lightGray,
    },
    text: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',

      '& .MuiTypography-root': {
        fontSize: 12,
      },
    },
    notFoundText: {
      fontSize: 12,
    },
    accessButton: {
      padding: 0,
      '& .MuiSvgIcon-root': {
        fontSize: 15,
        color: palette.blue,
      },
    },
    failedSessionsPercentage: {
      fontSize: 12,
      textAlign: 'center',
      fontWeight: 'bold',
      backgroundColor: palette.lightYellow,
      color: palette.darkYellow,
    },
    red: {
      backgroundColor: palette.lightRed,
      color: palette.darkRed,
    },
  });
